// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1VLzp","header":"ClearentDisclaimer_header__2M_AK","inner":"ClearentDisclaimer_inner__1CkTp"};